import { Control } from "react-hook-form";
import AdditionalCard from "./AdditionalCard";
import LocationCard from "./LocationCard";
import SupplierInfoCard from "./SupplierInfoCard";

export interface SupplierRegisterFieldsProps {
  control: Control<any>;
  country: number;
  onCountryChange: (country: number) => void;
  isSupplierAsUser: boolean;
  onIsSupplierAsUserChange: (value: boolean) => void;
  showRegisterAsUserCheckbox?: boolean;
}

/**
 * The three supplier-info/location/additional cards, stacked — the shared
 * "supplier form fields" building block. Used by the supplier Edit drawer
 * (`lcaSupplier/supplierEdit/SupplierEditModal.tsx`) inside its own Sheet
 * shell, and directly (no shell — this renders inline inside an existing
 * modal) by the Ingredient register flow's "register a new supplier"
 * section, replacing the legacy `SuppllierRegisterForm` there behind
 * `ENABLE_LCA_SUPPLIER_UI_REDESIGN`.
 */
const SupplierRegisterFields = ({
  control,
  country,
  onCountryChange,
  isSupplierAsUser,
  onIsSupplierAsUserChange,
  showRegisterAsUserCheckbox
}: SupplierRegisterFieldsProps) => {
  return (
    <div className="tw-flex tw-flex-col tw-gap-6">
      <SupplierInfoCard control={control} isSupplierAsUser={isSupplierAsUser} />
      <LocationCard control={control} country={country} onCountryChange={onCountryChange} />
      <AdditionalCard
        control={control}
        isSupplierAsUser={isSupplierAsUser}
        onIsSupplierAsUserChange={onIsSupplierAsUserChange}
        showRegisterAsUserCheckbox={showRegisterAsUserCheckbox}
      />
    </div>
  );
};

export default SupplierRegisterFields;
